import { render, staticRenderFns } from "./DiseaseBank.vue?vue&type=template&id=2c979fb2&scoped=true"
import script from "./DiseaseBank.vue?vue&type=script&lang=js"
export * from "./DiseaseBank.vue?vue&type=script&lang=js"
import style0 from "./DiseaseBank.vue?vue&type=style&index=0&id=2c979fb2&prod&scoped=true&lang=css"
import style1 from "./DiseaseBank.vue?vue&type=style&index=1&id=2c979fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c979fb2",
  null
  
)

export default component.exports